import React from "react";
import FadeIn from "react-fade-in";
import { StarterPolicy } from "./types";
import Button from "../Button";
import { AiOutlineArrowRight } from "react-icons/ai";
import { RulesAndDataDiagram } from "./subcomponents/Diagrams";

export const IntroPage: React.FC<{
  policy: StarterPolicy;
  onBack: () => void;
  onComplete: () => void;
}> = ({ policy, onComplete }) => {
  return (
    <div className="mx-auto max-w-[800px]">
      <h2 className="text-2xl mb-5">Oso Authorization Basics</h2>

      <p className="mb-6">
        Below is a visual representation of how Oso combines rules and facts to
        make authorization decisions. This is the policy that we&apos;ll be
        building in the next steps.
      </p>

      <FadeIn>
        <RulesAndDataDiagram policy={policy} />

        <div className="mt-6 flex justify-end">
          <Button
            theme="primary"
            icon={<AiOutlineArrowRight />}
            medium
            onClick={onComplete}
          >
            Got it
          </Button>
        </div>
      </FadeIn>
    </div>
  );
};
